import React from "react";
import PropTypes from "prop-types";
import InputGroup from "@components/input-group";
import SvgIcon from "@components/icon/svg";
import cx from "classnames";

class InputNumber extends React.Component {
  constructor(props) {
    super(props);

    this.handleIncClick = this.handleIncClick.bind(this);
    this.handleDecClick = this.handleDecClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  /** 获取当前 UI 上显示的值 **/
  getCurrentVisibleValue() {
    const { value, placeholder } = this.props.input || {};
    if (value === "" || value === undefined || value === null) {
      const numberPlaceholder = Number(placeholder);
      if (numberPlaceholder > 0 || placeholder === 0 || placeholder === "0") {
        return numberPlaceholder;
      }
    }
    return value;
  }

  handleIncClick() {
    const { input, touchFieldOnButtonClick } = this.props;
    const { onFocus, onBlur } = input;
    const cur = Number(this.getCurrentVisibleValue()) || 0;
    const touch = touchFieldOnButtonClick && onFocus && onBlur;
    if (touch) onFocus();
    this.handleChange(cur + this.props.step);
    if (touch) window.requestAnimationFrame(() => onBlur());
  }

  handleDecClick() {
    const { input, touchFieldOnButtonClick } = this.props;
    const { onFocus, onBlur } = input;
    const cur = Number(this.getCurrentVisibleValue()) || 0;
    const touch = touchFieldOnButtonClick && onFocus && onBlur;
    if (touch) onFocus();
    this.handleChange(cur - this.props.step);
    if (touch) window.requestAnimationFrame(() => onBlur());
  }

  handleChange(newValue) {
    const { min, max, allowClear, input } = this.props;
    const oldValue = input.value;
    if (allowClear && !newValue && newValue !== 0) {
      if (!oldValue && oldValue !== 0) {
        return;
      }
      return input.onChange("");
    }
    let num = Number(newValue);
    if (isNaN(num)) num = typeof newValue === "string" ? newValue.replace(/[^\d]/g, "") : 0;
    const actualNewValue = Math.max(min, Math.min(max, num));
    if (actualNewValue === oldValue) return;
    return input.onChange(actualNewValue);
  }

  handleInputChange(e) {
    this.handleChange(e.target.value);
  }

  handleKeyDown(e) {
    const code = e.keyCode;

    if (code === 38) {
      // add
      this.handleIncClick();
    } else if (code === 40) {
      // minus
      this.handleDecClick();
    }
  }

  render() {
    const { className, btnDec, btnInc, editable, input, inputGroup, min, max } = this.props;

    const visibleValue = Number(this.getCurrentVisibleValue());

    return (
      <InputGroup
        className={cx("input-number", {
          [`${className}`]: !!className,
          "inputNumber-readOnly": !editable,
        })}
        textAlign="center"
        groupSize="sm"
        groupWidth=".8rem"
        {...inputGroup}
        prefix={
          <button
            type="button"
            onClick={this.handleDecClick}
            disabled={visibleValue <= min}
            className={cx("inputNumber__btn", "inputNumber__btn-minus", {
              disabled: visibleValue <= min,
            })}
          >
            {btnInc}
          </button>
        }
        input={{
          placeholder: visibleValue,
          ...input,
          type: "text",
          readOnly: !editable,
          onChange: this.handleInputChange,
          onKeyDown: this.handleKeyDown,
        }}
        suffix={
          <button
            type="button"
            onClick={this.handleIncClick}
            disabled={visibleValue >= max}
            className={cx("inputNumber__btn", "inputNumber__btn-plus", {
              disabled: +input.value >= max,
            })}
          >
            {btnDec}
          </button>
        }
      />
    );
  }
}

InputNumber.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  step: PropTypes.number,
  className: PropTypes.string,
  btnDec: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  btnInc: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  editable: PropTypes.bool,
  inputGroup: PropTypes.any,
  input: PropTypes.object,
  allowClear: PropTypes.bool,
  touchFieldOnButtonClick: PropTypes.bool,
};

InputNumber.defaultProps = {
  max: Infinity,
  min: 0,
  step: 1,
  className: "",
  btnDec: <SvgIcon symbol={require("@shared/icons/plus.svg")} />,
  btnInc: <SvgIcon symbol={require("@shared/icons/minus.svg")} />,
  editable: true,
  inputGroup: {},
  allowClear: false,
  input: {
    value: 0,
    name: "",
    onChange: v => v,
  },
  touchFieldOnButtonClick: false,
};

export default InputNumber;

require("./index.less");
require("./index.less");